import styled from 'styled-components';

export const Container = styled.div`
  left: 0;
  top: 56px;
  width: 100vw;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  z-index: 9;
  padding: 22px 26px 26px;

  @media only screen and (max-width: 768px) {
    height: calc(100vh - 56px);
    overflow-y: scroll;
    padding: 14px 18px 18px;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .menu-mobile {
    font-size: 13px;
    margin-bottom: 8px;
  }

  .search-bar {
    display: flex;
    align-items: center;
    gap: 11px;
    background: #fff;
    border: 1.5px solid #e3e8f0;
    border-radius: 10px;
    padding: 11px 15px;
    margin-bottom: 18px;

    > svg {
      color: #8a94a6;
      flex-shrink: 0;
    }

    input {
      flex: 1;
      border: none;
      outline: none;
      font-size: 15px;
      color: #1f2c49;
      background: transparent;
      font-family: inherit;
      min-width: 0;
    }

    .clear-btn {
      display: inline-flex;
      background: transparent;
      border: none;
      padding: 0;
      color: #8a94a6;
      cursor: pointer;
    }

    @media only screen and (max-width: 768px) {
      border-radius: 11px;
    }
  }

  .recents {
    display: flex;
    align-items: center;
    gap: 12px;
    border-bottom: 1px solid #eef1f5;
    padding-bottom: 20px;
    margin-bottom: 22px;

    .recents-label {
      display: flex;
      align-items: center;
      gap: 7px;
      color: #6b7587;
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.06em;
      white-space: nowrap;

      svg {
        color: #8a94a6;
      }
    }

    .recents-chips {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    @media only screen and (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      padding-bottom: 14px;
      margin-bottom: 14px;
    }
  }

  .empty-state {
    padding: 30px;
    text-align: center;
    color: #8a94a6;
    font-size: 15px;
  }

  .tools-grid {
    column-count: 4;
    column-gap: 34px;

    .category-block {
      break-inside: avoid;
      display: inline-block;
      width: 100%;
      margin-bottom: 24px;
    }
  }

  .category-header {
    display: flex;
    align-items: center;
    gap: 9px;
    margin-bottom: 9px;

    .category-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 27px;
      height: 27px;
      flex-shrink: 0;
      background: #e7f4f1;
      color: #1b9e8d;
      border-radius: 8px;
    }

    h6 {
      font-size: 11.5px;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: #1f2c49;
      line-height: 1.2;
      margin: 0;
    }
  }

  .tools-accordion {
    .accordion-section {
      border-bottom: 1px solid #eef1f5;
    }

    .accordion-head {
      display: flex;
      align-items: center;
      gap: 12px;
      width: 100%;
      padding: 15px 4px;
      background: #fff;
      border: none;
      cursor: pointer;
      text-align: left;

      &.open {
        background: #f8fafc;
      }

      .category-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        flex-shrink: 0;
        background: #e7f4f1;
        color: #1b9e8d;
        border-radius: 8px;
      }

      .category-name {
        flex: 1;
        font-size: 14.5px;
        font-weight: 700;
        color: #1f2c49;
      }

      .category-count {
        font-size: 12px;
        font-weight: 700;
        color: #a3adbd;
      }

      > svg {
        color: #8a94a6;
        flex-shrink: 0;
      }
    }

    .accordion-items {
      padding: 2px 0 12px 8px;
    }
  }

  /* Defesa: o dropdown é renderizado dentro do <Nav>, e o header de
     representante pinta todo <button> do Nav com !important (header/styles.ts).
     Tripla especificidade para vencer em qualquer variante do header. */
  &&& .clear-btn {
    background: transparent !important;
  }

  &&& .accordion-head {
    background: #fff !important;
  }

  &&& .accordion-head.open {
    background: #f8fafc !important;
  }
`;
